<template>
    <b-form-group :label="value.label">
        <b-form-input type="text" class="form-control" :placeholder="value.label" v-model="value.value"/>
    </b-form-group>
</template>

<script>
    export default {
        props: ['value'],
    }
</script>
